// Though RoundedBanner is a server component and this could be in the same
// file, it's separate to avoid circular dependency between PDP and course page.
export const roundedBannerFragment = `
  fragment roundedBannerFragment on RoundedBannerRecord {
    bannerBackground {
      backgroundColor
    }
    button {
      ...buttonFragment
    }
    content {
      value
    }
    headingProps {
      textStyle
    }
    image {
      responsiveImage {
        ...responsiveImageFragment
      }
    }
    logos {
      responsiveImage(
        imgixParams: {
          fit: crop,
          q: 45,
          w: 36,
          h: 36,
          auto: format,
          mask: ellipse
        }
      ) {
        ...responsiveImageFragment
      }
    }
    moduleFormat {
      ...moduleFormatFragment
    }
    nurturingForm {
      form {
        active
        buttonText
        emailLabel
        emailPlaceholder
        emailValidationMessages {
          invalidMessage
          lengthMessage
          requiredMessage
        }
        errorMessage
        legalText {
          blocks
          links
          value
        }
        newsletterLabel
        newsletterEnabled
        salesforceSource
        successMessage
      }
    }
    title
  }
`;
